import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import { Button } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";
import Pagination from "react-bootstrap/Pagination";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";

import "./src/css/convenios-print.css";
import { myBreadCrumbsConv3lv, myBreadCrumbsConv4lv } from "./Handlers/BreadCrumbsConv";
const apiURL = process.env.REACT_APP_API_URL;
let paginadorTotal: number;


export default observer(function ListaConvenios() {
  let isMounted = true;
  let items: any = [];

  const handlePageClick = (numberPagina: number) => { setCurrentPage(numberPagina) };
  const [currentPage, setCurrentPage] = useState(1);
  const [convenio, setConvenios] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userStore: { user, roles } } = useStore();
  let activeC: string = "Lista de convenios"

  let url = apiURL + `/CATConvenios/${currentPage}/10`;

  const listaConvenios = async () => {
    setLoading(true);
    try {
      const responseConvenio = await axios(url);
      const { data } = responseConvenio;
      paginadorTotal = data.totalPages;

      const convenios = data.records.map(
        (dataR: {
          key: number;
          id: number;
          monto: number;
          fecha: any;
          descuento: number;
          codigoInstitucional: string;
          sgtEntidad: any;
        }) => {

          let urlConv = url + "/" + dataR.id;

          return {
            key: dataR.id,
            id: dataR.id,
            fecha: dataR.fecha,
            monto: dataR.monto,
            descuento: dataR.descuento,
            convenio: dataR.codigoInstitucional,
            url: urlConv,
            entidad: dataR.sgtEntidad?.entidad,
          };
        }
      );


      if (isMounted) {
        setConvenios(convenios);
        setLoading(false);
      }
    } catch (error) {
      // Manejar errores de solicitud aquí
    };


  };

  useEffect(() => {
    listaConvenios();
    return () => {
      isMounted = false;
    };
  }, [currentPage]);

  for (let numberPagina = 1; numberPagina <= paginadorTotal; numberPagina++) {
    const pageNumber = numberPagina;
    items.push(
      <Pagination.Item
        key={pageNumber}
        active={currentPage === pageNumber}
        activeLabel={""}
        onClick={() => {
          handlePageClick(pageNumber);
        }}
      >
        {pageNumber}
      </Pagination.Item>
    );
  }
  const ConvenioItems = (dataR: {
    key: number;
    id: number;
    fecha: any;
    monto: number;
    descuento: number;
    convenio: string;
    url: any;
    entidad: any;
  }) => {
    let montoConv = new Intl.NumberFormat("es-GT").format(dataR.monto);
    let descuentoB = dataR.descuento / 100;
    let descuentoT = dataR.monto - dataR.monto * descuentoB;
    let motoConDes = new Intl.NumberFormat("es-GT").format(descuentoT);
    const convURL = "/home/operaciones/convenios/" + dataR.id;

    function montoLogic(obj: number) {
      if (obj <= 0) {
        return "Exoneracion Total";
      } else if (obj >= 1 && dataR.descuento == 0) {
        return "Q. " + montoConv + ".00";
      } else if (obj >= 1 && dataR.descuento >= 1) {
        return "Q. " + motoConDes + ".00";
      }
    }

    return (
      <li key={dataR.id}>
        <Container className="convenio-body-item">
          <div className="convenio-body-section conv-sect1">
            {dataR.convenio}
          </div>
          <div className="convenio-body-section conv-sect2">
            {dataR.entidad}
          </div>
          <div className="convenio-body-section conv-sect3">
            {calculoFechas(dataR.fecha)}
          </div>
          <div className="convenio-body-section conv-sect4">
            {montoLogic(dataR.monto)}
          </div>
          <div className="convenio-body-section conv-sect5">


            <Link to={convURL}>
              <Button className="link">
                Modificar
              </Button>
            </Link>

          </div>
        </Container>
      </li>
    );
  };

  return (
    <>
      <Container className="solicitudes-area-head head-institu">

        <div className="title-area-institu solicitudes-area-head" >
          <h2>Listado de Códigos institucionales</h2>
        </div>

        <div className="bread-institu-internals">
          {myBreadCrumbsConv4lv(activeC)}
        </div>

      </Container>

      <Container className="convenios-section">
        <Container>
          <Row>
            <Col className="buscar-convenio-area">
              <Form.Control placeholder="Buscar código" />
              <Button variant="primary">Buscar</Button>{" "}
            </Col>

            <Col className="crear-convenio-area">
              {/* <Link to="/cargapagos/crear-convenio">
                <Button variant="success" className="link">
                  Crear nuevo código
                </Button>
              </Link> */}
            </Col>
          </Row>
        </Container>

        <Container className="convenio-head-list">
          <div className="convenio-head-section conv-sect1">Código Institucional</div>
          <div className="convenio-head-section conv-sect2">Entidad</div>
          <div className="convenio-head-section conv-sect3">Fecha</div>
          <div className="convenio-head-section conv-sect4">Monto</div>
          <div className="convenio-head-section conv-sect5">Acciones</div>
        </Container>

        <Container className="convenio-body-list">
          {loading ? (
            <LoadingComponent content="Cargando lista de códigos..." />
          ) : (
            <>
              <ul>
                {convenio.map(
                  (convenio: {
                    key: number;
                    id: number;
                    fecha: any;
                    monto: number;
                    descuento: number;
                    convenio: string;
                    url: any;
                    entidad: any;
                  }) => (
                    <ConvenioItems {...convenio} />
                  )
                )}
              </ul>
            </>
          )}
        </Container>

        <Container className="pagination-convenios-area">
          <Pagination>{items}</Pagination>
        </Container>
      </Container>
    </>
  );
});
